module.exports = __webpack_public_path__ + "static/media/eye.2827dc68.svg";